import {Directive, ElementRef, Renderer2} from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[stickyBody]' // eslint-disable-line @angular-eslint/directive-selector
})
export class StickyBodyDirective {
  constructor(
    public element: ElementRef,
    private render: Renderer2
  ) {
    this.render.addClass(this.element.nativeElement, 'myvf-sticky-body');
  }
}
